<div class="card text-center">
  <div class="close-btn icon material-icons" (click)="closeModal()">close</div>
  <img class="benefit-img rounded" width="100" height="100" src="{{ benefit.ImageFileName | contentImage: '1' }}" />

  <div class="mt-3 mb-4">
    <div class="font-size-18 text-name text-secondary mb-2 fw-bold">{{ benefit.Name | titlecase }}</div>
    <div class="font-size-12">Exp: {{ benefit.EndDate | date: 'longDate' }}</div>
  </div>
  <div class="font-size-14 description mb-3">{{ benefit.Description }}</div>

  <ng-container *ngIf="classifyStatusOfBenefit != BUTTON_STATUS.AddBenefit || claimLimit != null">
    <div class="font-size-14 mb-3">{{ 'benefit.last.date.chose' | translate }} {{ benefit.EndDate | date: 'longDate' }}</div>
  </ng-container>

  <ng-container [ngSwitch]="classifyStatusOfBenefit">
    <ng-container *ngSwitchCase="BUTTON_STATUS.AddBenefit">
      <ng-container *ngIf="claimLimit != null">
        <div class="benefit-confirm-description">
          <div class="font-size-14 text-primary mb-2 fw-bold text-secondary">
            {{ 'benefit.confirm.modal.description' | translate }}
          </div>
          <div class="font-size-12 mb-4">{{ 'benefit.confirm.modal.subheading' | translate }}</div>
        </div>
        <fgbcl-errors></fgbcl-errors>
        <button
          *ngIf="numberClaimed < claimLimit && !inactive"
          (click)="claimBenefit()"
          class="btn btn-benefit btn-benefit-add rounded bg-secondary border-secondary text-white fw-bold"
        >
          {{ 'add.benefit' | translate }}
        </button>
      </ng-container>
    </ng-container>

    <button
      *ngSwitchCase="BUTTON_STATUS.OutOfStock"
      class="btn btn-benefit btn-secondary btn-benefit-out-of-stock rounded text-white fw-bold disabled"
    >
      {{ 'benefit.button.out.of.stock' | translate }}
    </button>
    <button
      *ngSwitchCase="BUTTON_STATUS.ComingSoon"
      class="btn btn-benefit btn-secondary btn-benefit-comming-soon rounded text-white fw-bold disabled"
    >
      {{ 'benefit.button.coming.soon' | translate }}
    </button>
    <button
      *ngSwitchCase="BUTTON_STATUS.Expiried"
      class="btn btn-benefit btn-outline-secondary btn-benefit-expiried rounded fw-bold disabled"
    >
      {{ 'benefit.button.expiried' | translate }}
    </button>
  </ng-container>
</div>
